import { useRef } from 'react';
import { randomId } from '@/lib/randomId';

/**
 * One create key per Save intent (#228). The same key is reused while the content is unchanged,
 * so a retry after a lost response returns the row that was already created instead of a second
 * one; changing anything starts a new intent (the server returns the existing row for a key
 * without comparing the body, so a corrected value must never reuse the old key). A success
 * clears it. `slot` separates several drafts saved from one screen.
 */
export function useIdempotencyKey() {
  const current = useRef(new Map<string, { fingerprint: string; key: string }>());
  return {
    keyFor(fingerprint: string, slot = ''): string {
      const held = current.current.get(slot);
      if (held?.fingerprint === fingerprint) return held.key;
      const key = randomId();
      current.current.set(slot, { fingerprint, key });
      return key;
    },
    reset(slot = '') {
      current.current.delete(slot);
    },
  };
}
